import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PerformanceCollectionStore, for use in the registry */ export const PerformanceCollectionStoreActionTypes = [
    ActionType.ViewRenderAction,
    ActionType.StartTrackedInteractionAction,
    ActionType.CompleteTrackedInteractionAction
];
